let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Rwzq")).then(() => parcelRequire('f9u2E'));